import { themedStyled } from 'common/styles/styletron.theme';

export const PickerContainer = themedStyled<
  'div',
  {
    $maxWidth?: string;
  }
>('div', ({ $maxWidth }) => ({
  maxWidth: $maxWidth,
}));

export const MainPreviewContainer = themedStyled('div', () => ({
  flexDirection: 'row',
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '-12px',
  marginBottom: '12px',
  marginLeft: '-1%',
  marginRight: '-1%',
}));

export const MainDropzoneContainer = themedStyled<
  'div',
  {
    $error?: boolean;
  }
>('div', ({ $theme, $error }) => ({
  borderRadius: '8px',
  border: `2px dashed ${$theme.colors.primary300}`,
  padding: '4px',
  cursor: 'pointer',
  backgroundColor: $theme.colors.primary100,
  ...($error
    ? {
        border: `2px dashed ${$theme.colors.borderNegative}`,
      }
    : {}),
}));

export const BorderContainer = themedStyled<
  'div',
  {
    $error?: boolean;
  }
>('div', ({ $theme, $error }) => ({
  // border: '1px grey dashed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px',
  minHeight: '70px',

  ...($error
    ? {
        border: `1px dashed ${$theme.colors.borderNegative}`,
      }
    : {}),
}));

export const TextContainer = themedStyled('div', {
  display: 'flex',
  flexDirection: 'row',
});

export const PreviewContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '22%',
  marginTop: '12px',
  borderRadius: '8px',
  marginLeft: '1%',
  marginRight: '1%',
  [`${$theme.mediaQuery.sm}`]: {
    width: '66px',
  },
}));

export const PreviewSeparator = themedStyled('div', {
  marginLeft: '1%',
  marginRight: '1%',
});

export const ImagePreviewContainer = themedStyled('div', ({ $theme }) => ({
  width: '100%',
  paddingTop: '100%',
  cursor: 'pointer',
  border: `2px dashed ${$theme.colors.primary400}`,
  position: 'relative',
  borderRadius: '8px',
  height: '100%',

  ':hover:after': {
    content: '" "',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    zIndex: 1,
    position: 'absolute',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
  },
}));

export const LoadingContainer = themedStyled('div', {
  position: 'absolute',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const ImagePreview = themedStyled('img', {
  position: 'absolute',
  top: '0',
  left: '0',
  bottom: '0',
  objectFit: 'cover',
  right: '0',
  width: '100%',
  height: '100%',
  borderRadius: '8px',
});

export const FilePreview = themedStyled('img', {
  position: 'absolute',
  top: '0',
  objectFit: 'contain',
  left: '0',
  bottom: '0',
  right: '0',
  padding: '8px',
  width: '100%',
  height: '100%',
  borderRadius: '8px',
});

export const ActionContainer = themedStyled('img', {
  width: '100%',
  height: '100%',
});

export const PreviewText = themedStyled('span', {
  fontSize: '14px',
});

export const RemoveImage = themedStyled('div', {
  position: 'absolute',
  top: '-6px',
  right: '-6px',
  backgroundColor: '#e75b64',
  color: 'white',
  borderRadius: '50%',
  fontSize: '16px',
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  userSelect: 'none',
  margin: '0 !important',
  zIndex: 2,
});

export const EditComponent = themedStyled('div', {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  padding: '2px 2px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  zIndex: 2,
  borderRadius: '0 0 8px 8px',
});
